import { DEFAULT_REFRESH_INTERVAL } from '../constants'
import { Device, WindowSize } from '../helpers'
import WebModel from '../models/WebModel'
import { Slot } from './Slot'
import { ExperimentFlag } from '../enums/ExperimentFlag'

export const MOBILE_ADUNIT_ID = 'recipe_mobile'
export const DESKTOP_ADUNIT_ID = 'recipe_btf'

export class Recipe extends Slot {
  refreshTime = DEFAULT_REFRESH_INTERVAL
  _sizes = [[300, 250]] as AdSizes
  lazy = true
  slotName = 'recipe'

  constructor(slotModel: ISlotModel, model: WebModel) {
    super(slotModel, model)

    this.selector =
      Device.isMobileOrTablet && slotModel.mobileSelector
        ? slotModel.mobileSelector
        : slotModel.selector

    this.insertPosition =
      Device.isMobileOrTablet && slotModel.mobileInsertPosition
        ? (slotModel.mobileInsertPosition as InsertPosition)
        : (slotModel.insertPosition as InsertPosition)

    this.adUnitId = Device.isMobileOrTablet
      ? MOBILE_ADUNIT_ID
      : DESKTOP_ADUNIT_ID

    const offsetMultiplier = parseFloat(
      model.experiment.activate<string>(ExperimentFlag.recipeOffset) ||
        '1.00001'
    )
    this.offset = WindowSize.height * offsetMultiplier
    this.setTargeting({ offsetMultiplier })
  }

  get id(): string {
    if (this.number === 1) {
      return this.adUnitId
    } else {
      return this.adUnitId.replace('_', `_${this.number}_`)
    }
  }

  template(): string {
    const template = super.template()

    return Device.isMobileOrTablet
      ? `
        <div class='remove_padding'>
          ${template}
        </div>
      `
      : template
  }
}
